<div class="app-container">
  <div class="main-content">
    <!-- Search and Filter Section -->
    <div class="search-filter-section">
      <app-searchbar
        placeholder="Search by license plate..."
        [(searchTerm)]="searchTerm"
        (searchChange)="onSearchChange($event)"
        iconSize="small"
      >
      </app-searchbar>

      <button class="tunnel-logout-btn" (click)="logout()" title="Log out">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
            fill="currentColor"
          />
        </svg>
        Log Out
      </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <app-loading-table-shimmer
        [columns]="shimmerColumns"
        [rows]="10"
        [showHeader]="false"
        className="scrollable"
      >
      </app-loading-table-shimmer>
    </div>

    <!-- Card + Detail Layout -->
    <div *ngIf="!loading" class="tunnel-layout">
      <!-- Left: Card List -->
      <div class="card-list-panel" [class.is-empty]="orders.length === 0">
        <!-- Empty State - No Orders -->
        <div *ngIf="orders.length === 0 && !hasSearchOrFilters" class="empty-state-container">
          <app-empty-result
            image="/assets/images/empty_screen.png"
            title="No orders for today"
            description="There are no orders recorded at this location for today."
            [actionText]="''"
            [showAction]="false"
          >
          </app-empty-result>
        </div>

        <!-- Empty State - No Search Results -->
        <div *ngIf="orders.length === 0 && hasSearchOrFilters" class="empty-state-container">
          <app-empty-result
            image="/assets/images/empty_screen.png"
            title="No results found!"
            description="Please try again or modify your search or filters."
            [actionText]="''"
            [showAction]="false"
          >
          </app-empty-result>
        </div>

        <!-- Order Cards -->
        <div
          *ngFor="let order of orders"
          class="order-card"
          [class.active]="isSelectedTile(order)"
          [class.new-order]="isNewTile(order)"
          [class.tunnel-sent]="tunnelWashRowFor(order)?.tone === 'sent'"
          (click)="selectCard(order)"
        >
          <span class="rewash-chip" *ngIf="order.isRewash">REWASH</span>

          <!-- Delete Button -->
          <button class="card-delete-btn" (click)="deleteOrder(order, $event)" title="Delete order">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3 6H5H21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6L18.1168 19.1289C18.0827 19.6474 17.8506 20.1327 17.4669 20.4844C17.0833 20.8361 16.5771 21.0286 16.0573 21.0286H7.94274C7.42293 21.0286 6.91672 20.8361 6.53307 20.4844C6.14942 20.1327 5.91728 19.6474 5.8832 19.1289L5 6H19Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <div class="license-plate-display">
            <span class="plate-prefix">{{
              getLicensePlateParts(order.licensePlate).prefix || '-'
            }}</span
            ><span class="plate-suffix">{{
              getLicensePlateParts(order.licensePlate).suffix || '-'
            }}</span>
          </div>

          <span class="card-package-label" *ngIf="order.packageName">
            {{ order.packageName || '-' }}
          </span>
          <!-- CWS-1444: the label above is the plan the membership is on now.
               This says what it was sold on, so staff can see the order changed
               without having to open the membership. -->
          <span
            class="card-package-label card-package-label--current"
            *ngIf="order.planChanged && order.soldPackageName"
            [title]="'Now on ' + order.packageName + ' (sold as ' + order.soldPackageName + ')'"
          >
            Sold as: {{ order.soldPackageName }}
          </span>

          <!-- CWS-1921: Tunnel Controller wash state of this row. -->
          <div
            *ngIf="tunnelWashRowFor(order) as wash"
            class="card-tunnel-wash"
            [ngClass]="'card-tunnel-wash--' + wash.tone"
            [attr.role]="wash.tone === 'error' || wash.tone === 'unconfirmed' ? 'alert' : null"
          >
            <span class="card-tunnel-wash__text">{{ wash.text }}</span>
            <span
              class="card-tunnel-wash__countdown"
              *ngIf="wash.removeInSeconds !== null"
              [attr.aria-label]="wash.removeInLabel"
              >{{ wash.removeInSeconds }}s</span
            >
          </div>

          <div class="card-bottom-row">
            <span
              class="card-vehicle-row"
              [class.unavailable]="getMakeModel(order) === 'Vehicle make not available'"
            >
              {{ getMakeModel(order) || '-' }}
            </span>
            <span class="order-datetime">
              {{ order.dateTime || '-' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Right: Detail Panel -->
      <div class="order-detail-panel">
        <ng-container *ngIf="selectedCardOrder; else noOrderSelected">
          <!-- Customer Header -->
          <div class="detail-header">
            <div class="detail-header-date">{{ selectedCardOrder.dateTime || '-' }}</div>
            <div class="detail-customer-name">{{ getTunnelPackageTitle(selectedCardOrder) }}</div>
            <button
              class="detail-delete-btn"
              (click)="deleteOrder(selectedCardOrder, $event)"
              title="Delete order"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3 6H5H21"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6L18.1168 19.1289C18.0827 19.6474 17.8506 20.1327 17.4669 20.4844C17.0833 20.8361 16.5771 21.0286 16.0573 21.0286H7.94274C7.42293 21.0286 6.91672 20.8361 6.53307 20.4844C6.14942 20.1327 5.91728 19.6474 5.8832 19.1289L5 6H19Z"
                  stroke="#ffffff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Delete
            </button>
          </div>

          <!-- License Plate Highlight -->
          <div class="detail-plate-section">
            <div class="detail-plate-label">License Plate</div>
            <div class="detail-plate-value">
              <span class="plate-prefix">{{
                getLicensePlateParts(selectedCardOrder.licensePlate).prefix || '-'
              }}</span
              ><span class="plate-suffix">{{
                getLicensePlateParts(selectedCardOrder.licensePlate).suffix || '-'
              }}</span>
            </div>
          </div>

          <!-- Detail Fields -->
          <div class="detail-fields">
            <div class="detail-field">
              <span class="detail-field-label">{{
                selectedCardOrder.event === 'fleet-vehicle-found' ? 'Type' : 'Make & Model'
              }}</span>
              <span
                class="detail-field-value"
                [class.detail-value-unavailable]="
                  getMakeModel(selectedCardOrder) === 'Vehicle make not available'
                "
              >
                <span class="wash-type-badge"> {{ getMakeModel(selectedCardOrder) || '-' }}</span>
              </span>
            </div>

            <div class="detail-field" *ngIf="selectedCardOrder.washType">
              <span class="detail-field-label">{{
                selectedCardOrder.event === 'fleet-vehicle-found' ? 'Fleet' : 'Wash Type'
              }}</span>
              <span class="detail-field-value wash-type-cell">
                <span
                  class="wash-type-badge"
                  [ngClass]="
                    getWashTypeClass(selectedCardOrder.washType, selectedCardOrder.washTypeValue)
                  "
                >
                  {{ selectedCardOrder.washType || '-' }}
                </span>
                <!-- CWS-1125: a detailing / add-on sold with the wash is not in washType. -->
                <span
                  *ngFor="let addOnLabel of selectedCardOrder.addOnLabels"
                  class="wash-type-badge"
                  [ngClass]="getAddOnLabelClass(addOnLabel)"
                >
                  {{ addOnLabel }}
                </span>
              </span>
            </div>

            <app-tunnel-wash-summary
              class="detail-tunnel-wash"
              [order]="selectedCardOrder"
              [nowMs]="nowMs"
            ></app-tunnel-wash-summary>

            <div class="detail-image-section">
              <span class="detail-field-value">
                <!-- image_s3_url, else plate_image_s3_url (mapped into imageUrl) -->
                <img
                  *ngIf="selectedCardOrder.imageUrl"
                  [src]="selectedCardOrder.imageUrl"
                  alt="Order image"
                  class="order-image"
                />

                <div class="image-unavailable" *ngIf="!selectedCardOrder.imageUrl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#9CA3AF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                    <line x1="2" y1="2" x2="22" y2="22" stroke="#D1D5DB" />
                  </svg>
                  <span>Image not available</span>
                </div>
              </span>
            </div>
          </div>

          <!-- View Full Details
          <button class="detail-view-btn" (click)="openOrderDetails(selectedCardOrder)">
            View Full Details
          </button> -->
        </ng-container>

        <ng-template #noOrderSelected>
          <!-- <div class="detail-empty-state">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8" y="8" width="32" height="32" rx="6" stroke="#D1D5DB" stroke-width="2"/>
              <path d="M16 20H32M16 26H26" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <p>Select an order to view details</p>
          </div> -->
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [categories]="filterCategories()"
  (close)="onCloseFilterModal()"
  (apply)="onFilterModalApplyShared($event)"
>
</app-filter-modal>

<!-- Order Details Modal -->
<app-order-details-modal
  [order]="selectedOrder"
  [isOpen]="showOrderDetailsModal"
  (closeModal)="closeOrderDetails()"
  (orderCancelled)="onOrderCancelled()"
  (bookAgain)="closeOrderDetails()"
>
</app-order-details-modal>

<!-- Delete undo toast (replaces confirmation modal) -->
<div class="tunnel-delete-toast" *ngIf="deleteUndoToast" role="status" aria-live="polite">
  <div class="tunnel-delete-toast__content">
    <span class="tunnel-delete-toast__title">Order removed</span>
    <span class="tunnel-delete-toast__detail">{{ deleteUndoToast.licensePlate }}</span>
  </div>
  <button type="button" class="tunnel-delete-toast__undo" (click)="undoDeleteOrder()">Undo</button>
</div>
